import { Observable } from 'rxjs';
import { IAttribute } from '../attribute/IAttribute';
import { IAction } from '../action/IAction';

export enum NodeType { Class, Object };

export const ThresholdDisplayedSubNodes = 50;
export const LimitDisplayedSubNodes = 100;

export interface INode {
    name: string;
    readonly type: NodeType;
    isExpanded: boolean;
    subNodes: Array<INode>;
    readonly parent: INode;
    readonly structure: Object;
    readonly attributes: Array<IAttribute>;
    readonly isOneInstance: boolean;
    readonly isObjectNode: boolean;
    readonly isClassNode: boolean;
    readonly isGettable: boolean;
    readonly isCreatable: boolean;
    readonly isDeletable: boolean;
    readonly isUsed: boolean;
    isLocal: boolean;
    readonly isAttributesModified: boolean;
    readonly isModified: boolean;
    readonly isValid: boolean;
    readonly isFilterApplied: boolean;
    shouldApplyLimit: boolean;
    readonly localIdx: number;
    readonly actionNames: Array<string>;
    readonly objectData: Object;
    readonly filterCondition: Object;
    maxDisplayedSubNodes: number;
    readonly currentFilters: Object;
    sortOrder: Object;
    subNodesInitialLength: number;
    index: number;

    isUsedChanges(): Observable<boolean>;
    isValidChanges(): Observable<boolean>;
    isLocalChanges(): Observable<any>;
    isAttributesModifiedChanges(): Observable<boolean>;
    isExpandedChanges(): Observable<boolean>;
    nameChanges(): Observable<string>;
    isFilterAppliedChanges(): Observable<boolean>;
    sortOrderChanges(): Observable<Object>;

    /**
     * Creates the subnodes instances, based on the content of the current object.
     * May be asynchronous if subnodes data has to be retrieved remotely.
     * If current object is a class node : retrieves all the object instances of this class, and instanciates the corresponding list of ObjectNode
     * If current object is a object node : creates the list of ClassNode according to the subClasses defined in the model definition for this object
     */
    getPath(): string;
    getNodePath(): Array<INode>;
    getFilteringAttributes(): Array<IAttribute>;
    getMinimumFilteringAttributes(): Array<IAttribute>;
    getInitialAttributesToRetrieve(): Array<IAttribute>;
    getAttributeData(attr: IAttribute): Object;
    getLocalData(attributes: Array<IAttribute>): Object;
    updateData(objData: Object): void;
    updateAndCreateMissingData(objData: Object): void;
    evaluateUsedWhen(objectData: Object): void;
    evaluateSubNodesUsedWhen(): void;
    evaluateAttributesUsedWhen(): void;
    removeServerSubNodes(): void;
    copyIdlocalToValue(): void;
    updateAttributesWithLocal(objData: Object,dict:Object): void;
    setValidity(validity: boolean): void;
    setFilterCondition(filterCondition: Object, filterIndex?: number, enabled?: boolean): void;
    resetFilterCondition(keepCurrentFilters?: boolean): void;
    initDisplayedSubNodes(): void;
    resetDisplayedSubNodesLimit(): void;
    hasSubClass(): boolean;
    computeValidity(): void;
    getAttributeByName(attriName: string): IAttribute;
    clearLocalChanges(): void;
    removeAttributesMarkedToDelete(): void;
    removeLocalAttributes(): void;
    getSubNodes(): Array<INode>;
    getDisplayedSubNodes(start?: number, end?: number): Array<INode>;
    toggleSortCriteria(attribute: IAttribute): void;
    getSortCriteria(attribute: IAttribute): string;
    isAttributeSorted(attribute: IAttribute): boolean;
    deleteSortCriteria(attribute: IAttribute): void;
    deleteAllSortCriteria(): void;
    filterApplied(): void;
    setInitialAttributes(attributes: Array<IAttribute>): void;
    getSoleFilteringAttributeKey(): string;
    getActionByName(name: string): IAction;

    toString(): string;
}
